import { is, Record, Map } from 'immutable';
import { curry, map, mapObjIndexed, pick, pickBy } from 'ramda';
import schemaTypes from './schemaTypes';

export default function makeAllOperators(hierarchy, { withNone }) {
  let records = mapObjIndexed((ops, plug) => {
    return mapObjIndexed((op, name) => {
      return makeOperator(plug, op, name);
    }, ops);
  }, hierarchy);
  if (withNone) records.None = { NoOp: makeOperator('None', { schema: {} }, 'NoOp') };
  return records;
};

// export const Operator = Record({type: '', name: '', attributes: null});

function makeOperator(plug, op, name) {
  let props = map((info, key) => {
    if (schemaTypes[info.type]) return Object.assign({ type: info.type, schema: info }, schemaTypes[info.type](info));
    return {
      set: (v) => v,
      get: (v) => v,
    };
  }, op.schema);

  let keys = Object.keys(props);

  let defaults = map((prop, key) => prop.defaultValue, props);
  defaults.type = name;
  defaults.name = name;

  let references = pickBy((prop, key) => prop.isReference, props);
  let fileReferences = pickBy((prop, key) => prop.isFileReference, props);

  let Operator = class R extends Record(defaults, plug + name) {
    static keys() {
      return keys;
    }

    keys() {
      return keys;
    }

    getProperties() {
      return props;
    }

    getReferences() {
      return Map(pickBy((v) => !!v, mapObjIndexed((schema, key) => {
        return this.get(key);
      }, references)));
    }

    getFileReferences() {
      return Map(pickBy((v) => !!v, mapObjIndexed((schema, key) => {
        return this.get(key);
      }, fileReferences)));
    }

    typeOf(key) {
      return op.schema[key] && op.schema[key].type;
    }

    set(key, val) {
      const newVal = props[key] ? props[key].set(val) : val;
      return super.set(key, newVal);
    }

    export() {
      const op = mapObjIndexed((prop, key) => {
        const v = this.get(key);
        return fileReferences[key] || references[key] ? (v ? v.get('id') : null) : v;
      }, props);
      op.name = name;
      op.primitive = plug;
      return op;
    }

    doUpdate(operator, primitive, sceneId) {
      const result = op.update ? op.update.call(op, operator, primitive, sceneId) :
        operator.mergeInto(operator, primitive);
      if (!result) {
        console.error('Operator not returning its result: ', name, op);
      }

      return result || Map();
    }
  };
  return Operator;
}




// WEBPACK FOOTER //
// ./src/operators/makeAllOperators.js